@if (_currentData) {
  <div class="main-content-container card" id="coverSheet" [ngClass]="{ 'no-border': isHistoryFromPopup }">
    @if (_currentData.screenType == 'episode') {
      <div class="page-title-container d-flex">
        <div class="page-title flex-grow-1 ">
          <div class="mb-0 ">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2 ">
                @if (!isHistoryFromPopup) {
                  <a class="d-inline-flex" href="javascript:void(0)" (click)="backResource()">
                    <img src="assets/images/grid-back.png"></a>
                  }
                </div>
                <div class="">Episode Related Details </div>
              </div>
            </div>
          </div>
          <!-- <div class="component-container "></div> -->
        </div>
      }
      <div class="d-flex w-100 _isMobile">
        @if (_currentData.screenType == 'cover_sheet') {
          <div class="filter-orderset flex-1">
            <div class="radio-action-container">
              <div class="radio-container flex-wrap" style="padding: 10px;">
                <label class="radio-wrapper">All
                  <input type="radio" value="all" name="basedOn" [checked]="config.filter_based == 'all'"
                    (change)="getOrdersetData('all', undefined)">
                  <span class="check-mark-radio"></span>
                </label>
                <label class="radio-wrapper">Self
                  <input type="radio" value="self" name="basedOn" [checked]="config.filter_based == 'self'"
                    (change)="getOrdersetData('self', ',filter_based:self')">
                  <span class="check-mark-radio"></span>
                </label>
                <!-- <label class="radio-wrapper">Speciality
                <input type="radio" value="speciality" name="basedOn" [checked]="config.filter_based == 'speciality'"
                  (change)="getOrdersetData('speciality', ',filter_based:speciality')">
                <span class="check-mark-radio"></span>
              </label> -->
              <label class="radio-wrapper">Unit
                <input type="radio" value="unit" name="basedOn" [checked]="config.filter_based == 'unit'"
                  (change)="getOrdersetData('unit' ,',filter_based:unit')">
                <span class="check-mark-radio"></span>
              </label>
              <label class="radio-wrapper">Department
                <input type="radio" value="department" name="basedOn" [checked]="config.filter_based == 'department'"
                  (change)="getOrdersetData('department', ',filter_based:department')">
                <span class="check-mark-radio"></span>
              </label>
            </div>
          </div>
        </div>
      }
      <div class="d-flex justify-content-end mr-3">
        @if (_currentData.screenType == 'cover_sheet' && rolePermissionService.checkAccessPermission('secondary_uhid','coverSheet')) {
          <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
            (click)="secondaryUhidBtn();"
            style="display:flex;flex-direction: column;align-items: end;">
            <input class="custom-control-input" type="checkbox" [checked]=secondary_uhid_default>
            <label class="custom-control-label custom_secondary_class" style="padding-left: 45px;"></label>
            <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">{{'Merge UHID' |
            translate | async}}</p>
          </div>
        }
        @if (_currentData.screenType == 'cover_sheet' && rolePermissionService.checkAccessPermission('ehr_view','coverSheet')) {
          <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
            (click)="toggleAutoRefresh();"
            style="display:flex;flex-direction: column;align-items: end;margin-right: 2rem !important;">
            <input class="custom-control-input" type="checkbox" [checked]=ehr_view>
            <label class="custom-control-label" style="padding-left: 45px;"></label>
            <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">EHR</p>
          </div>
        }
        @if (_currentData.json == 'coverSheetAdvance' || _currentData.json == 'coverSheet') {
          <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
            (click)="layoutChange(_currentData.json == 'coverSheetAdvance')" style="display:flex;flex-direction: column;align-items: end;margin-right: 2rem !important;">
            <input class="custom-control-input" type="checkbox" [checked]="_currentData.json == 'coverSheetAdvance'">
            <label class="custom-control-label" style="padding-left: 45px;"></label>
            <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">Card View</p>
          </div>
        }
        @if (_currentData.screenType == 'cover_sheet' &&  _currentData.cards && _currentData.cards.length > 0) {
          <div class="settings-option">
            <span class="toggle-icn">
              <i [popover]="popTemplate" class="fa fa-cog" container="body"
                containerClass="tabelcontextualmenu table-header-menu" [outsideClick]="true"
              placement="left top"></i>
            </span>
            <ng-template #popTemplate>
              <div class="pl-3 p-2 p-dropdown-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" [checked]="config.viewAll == true"
                    (change)="HidetoggleVisibility($event.target.checked)"
                    class="custom-control-input" id="customCheck" name="example1">
                  <label class="custom-control-label" for="customCheck">{{'View All'
                  |translate |async}}</label>
                </div>
              </div>
              @for (action of _currentData.cards; track action) {
                <div class="pl-3 p-2 p-dropdown-item">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" [checked]="action.selected"
                      class="custom-control-input" id="{{action.displayName}}"
                      (change)="toggleVisibility($event,action)"
                      [disabled]="action.disabled && !action.hidden">
                    <label class="custom-control-label"
                    for="{{action.displayName}}">{{action.displayName}}</label>
                  </div>
                </div>
              }
              <div class="pl-3 p-2 p-dropdown-item">
                <a href="javascript:void(0)" (click)="delteConfigData()"> {{'Reset to
                Default' | translate | async}}</a>
              </div>
            </ng-template>
          </div>
        }
      </div>
    </div>
    @if (!(_currentData.json == 'coverSheetAdvance')) {
      <div class="card-body p-0">
        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pl-0 pr-0 pt-2">
          @for (current_card of _currentData.cards; track current_card; let i = $index) {
            <div class="col-12 no-padding-mobile">
              @if (current_card['finalData'] != undefined && current_card['finalData'].count !=undefined && current_card['finalData'].count > 0) {
                <div class="card dashboard-sta schedule-card">
                  <div class="card-header d-flex align-items-center bg-white border-0 py-1 only-padding-mobile">
                    <div class="_wf-cf-facilitytext p-2 flex-grow-1 bd-highlight">
                      <span class="secondary-header p-1 rounded">{{current_card.displayName}}
                        &nbsp;({{current_card['finalData'] ? (current_card['finalData'].count ?
                      current_card['finalData'].count:0):0}})</span>
                    </div>
                    @if (current_card['finalData'] != undefined) {
                      <div class="p-2 bd-highlight">
                        <span (click)="onClickArrowOpenPopup(current_card)">
                          <i class="fa fa-arrow-circle-right fa-2x" style="cursor: pointer;"></i></span>
                        </div>
                      }
                      <div class="p-2 bd-highlight">
                        <span data-toggle="collapse" aria-expanded="true"><i #iconRef
                          class="fa fa-angle-up fa-2x"
                        (click)="iconRef.classList.toggle('fa-angle-down');showCard.classList.toggle('show')"></i></span>
                      </div>
                    </div>
                    <div #showCard class="card-body schedule-card-body collapse show p-0"
                      style="padding: none; padding-top: 0px !important; min-height:0px !important;">
                      @if (current_card['finalData'] && current_card.list.fields) {
                        <dhs-data-grid
                          [data]="current_card['finalData']" [fields]="current_card.list.fields"
                          [config]="dataGridConfig" (emitCustomLink)="emitCustomLink($event)">
                        </dhs-data-grid>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      <!-- NEW COVER SHEET-->
      @if ((_currentData.json == 'coverSheetAdvance')) {
        <div class="new-cover-sheet-body-container">
          @for (current_card of _currentData.cards; track current_card) {
            <ng-container>
              <div class="new-cover-sheet-container" [hidden]="current_card.hidden">
                <div class="new-cover-sheet-container-body">
                  <div class="new-cover-sheet-header">
                    <p>{{current_card.displayName}}</p>
                    <i class="fa fa-expand" style="cursor: pointer;" (click)="onClickArrowOpenPopup(current_card)"></i>
                  </div>
                  <div class="new-cover-sheet-body">
                    <dhs-data-grid
                      [data]="current_card['finalData']" [fields]="current_card.list.fields"
                      [config]="dataGridConfig" (emitCustomLink)="emitCustomLink($event)" [rowClick]="true" (editEllipseClick)="buttonAction($event,current_card)">
                    </dhs-data-grid>
                  </div>
                </div>
              </div>
            </ng-container>
          }
        </div>
      }
    </div>
  }